import React from "react";
import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";
import { Image } from "antd";

const Container = styled.button(({ theme }) => ({
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  transition: "all 0.2s",
  border: "none",
}));

type Prop = {
  src: string;
  onClick: () => void;
  width?: string;
  height?: string;
};
const TabButton = ({ src, onClick, width, height }: Prop) => {
  const { t } = useTranslation();

  return (
    <Container onClick={onClick}>
      <Image
        src={src}
        preview={false}
        width={width ? width : "2.4rem"}
        height={height ? height : "2.4rem"}
      />
    </Container>
  );
};

export default TabButton;
